// PC 页面轻量 UI：纯 px 实现，不依赖 Vant/rem，避免与移动端适配体系冲突
let toastTimer = null;

export function pcToast(message) {
  let el = document.getElementById("pc-toast");
  if (!el) {
    el = document.createElement("div");
    el.id = "pc-toast";
    el.style.cssText =
      "position:fixed;top:36px;left:50%;transform:translateX(-50%);z-index:3000;" +
      "padding:10px 22px;border-radius:8px;background:rgba(22,59,92,0.88);" +
      "color:#fff;font-size:14px;line-height:1.5;box-shadow:0 6px 20px rgba(6,51,92,0.25);" +
      "display:none;max-width:70vw;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;";
    document.body.appendChild(el);
  }
  el.textContent = message;
  el.style.display = "block";
  clearTimeout(toastTimer);
  toastTimer = setTimeout(() => {
    el.style.display = "none";
  }, 2000);
}
